var _circle, _circle2, _circle3, _circle4, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmojiGood(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 126,
    height: 91,
    viewBox: "0 0 126 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 45.0069,
    cy: 45.0069,
    r: 45.0069,
    fill: "#52A831"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 102.513,
    cy: 17.5385,
    r: 8.70631,
    transform: "rotate(-39.7008 102.513 17.5385)",
    fill: "#52A831"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 119.821,
    cy: 21.4081,
    r: 4.38798,
    transform: "rotate(-39.7008 119.821 21.4081)",
    fill: "#52A831"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 114.641,
    cy: 3.9321,
    r: 2.79235,
    transform: "rotate(-39.7008 114.641 3.9321)",
    fill: "#52A831"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65.5464 64.7482C76.7319 53.5627 76.7319 35.4275 65.5464 24.242C54.361 13.0565 36.2257 13.0565 25.0402 24.242C13.8547 35.4275 13.8547 53.5627 25.0402 64.7482C36.2257 75.9337 54.361 75.9337 65.5464 64.7482Z",
    fill: "#FFD053"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2893 20.0444C63.7801 25.5075 65.3149 31.993 64.6429 38.4413C63.9709 44.8895 61.1318 50.9192 56.5894 55.5451C52.0471 60.171 46.0702 63.1195 39.6353 63.909C33.2003 64.6984 26.6879 63.2821 21.1621 59.8914C23.4822 63.5199 26.5906 66.5787 30.256 68.8401C33.9214 71.1015 38.0495 72.5074 42.3332 72.9532C46.617 73.399 50.9461 72.8733 54.9986 71.415C59.0511 69.9568 62.7227 67.6036 65.7402 64.5306C68.7578 61.4575 71.0436 57.7437 72.4277 53.6653C73.8119 49.5869 74.2586 45.2489 73.7348 40.974C73.211 36.6991 71.7301 32.5973 69.4022 28.9737C67.0744 25.3501 63.9595 22.298 60.2893 20.0444Z",
    fill: "#FFC448"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.55 47.5174C20.5504 41.9629 22.2898 36.5478 25.5241 32.0321C28.7585 27.5164 33.3255 24.1266 38.5843 22.3384C43.8432 20.5501 49.5299 20.4532 54.8466 22.0613C60.1633 23.6693 64.8431 26.9015 68.2294 31.3044C66.414 28.1464 63.9691 25.3949 61.0465 23.2206C58.124 21.0462 54.7859 19.4954 51.2393 18.6642C47.6927 17.8329 44.0132 17.7391 40.4288 18.3883C36.8444 19.0376 33.4316 20.4162 30.402 22.4387C27.3723 24.4612 24.7904 27.0844 22.8162 30.1458C20.842 33.2071 19.5177 36.6413 18.9253 40.2356C18.333 43.8298 18.4852 47.5073 19.3725 51.0403C20.2599 54.5733 21.8635 57.8863 24.0839 60.7741C21.7615 56.7425 20.5426 52.1701 20.55 47.5174V47.5174Z",
    fill: "#FFD77A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1279 50.3574C33.4686 53.348 34.898 56.1085 37.1436 58.1128C39.3891 60.117 42.2937 61.2247 45.3036 61.2247C48.3135 61.2247 51.2181 60.117 53.4637 58.1128C55.7092 56.1085 57.1386 53.348 57.4793 50.3574H33.1279Z",
    fill: "#71523F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8926 57.8779C39.1166 59.9807 42.0476 61.1742 45.1079 61.2232C48.1682 61.2722 51.1359 60.1731 53.4261 58.1426L53.3131 57.8792C45.1371 53.8921 37.0036 57.8238 36.8926 57.8779V57.8779Z",
    fill: "#FF6669"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M41.351 36.1659C41.351 36.1517 41.352 36.1378 41.352 36.1238C41.352 33.4783 39.4387 31.0562 36.5621 31.0562C34.276 31.0562 32.9506 32.6989 32.4983 34.2366C32.0464 32.6989 30.7206 31.0562 28.4347 31.0562C25.558 31.0562 23.6447 33.4783 23.6447 36.1238C23.6447 36.1378 23.6457 36.1517 23.6457 36.1659C23.6303 36.7414 23.6447 42.5979 32.4958 47.3715V47.3727H32.497H32.4983H32.4996H32.5011V47.3715C41.352 42.5979 41.3663 36.7414 41.351 36.1659V36.1659Z",
    fill: "#EF233C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M66.9555 36.1659C66.9555 36.1517 66.9565 36.1378 66.9565 36.1238C66.9565 33.4783 65.0432 31.0562 62.1664 31.0562C59.8805 31.0562 58.555 32.6989 58.1028 34.2366C57.6509 32.6989 56.3251 31.0562 54.0391 31.0562C51.1625 31.0562 49.2492 33.4783 49.2492 36.1238C49.2492 36.1378 49.2502 36.1517 49.2502 36.1659C49.2348 36.7414 49.2492 42.5979 58.1002 47.3715V47.3727H58.1015H58.1028H58.1041H58.1054V47.3715C66.9565 42.5979 66.9708 36.7414 66.9555 36.1659V36.1659Z",
    fill: "#EF233C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmojiGood);
export default __webpack_public_path__ + "static/media/EmojiGood.96d92d2189dc54be5d76a8b24f766450.svg";
export { ForwardRef as ReactComponent };